<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="COVID-19 Infantil"
            description="Crianças entre 6 meses e 4 anos"
            url="/vacina-idade-certa"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'COVID-19 Infantil',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
